// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2UH_w","info":"UpdateTermsInfo_info__3bW7A"};